"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _zod = require("zod");

var _LastVisitors = _interopRequireDefault(require("../widget-last-visitors/LastVisitors.sync"));

var _classnames = _interopRequireDefault(require("classnames"));

var widgetName = 'statistics_bar';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-statistics_bar';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  total_topics: _zod.z.boolean().optional(),
  total_comments: _zod.z.boolean().optional(),
  total_users: _zod.z.boolean().optional()
});

exports.config = config;

var CommunityStatisticsWidget = function CommunityStatisticsWidget(props) {
  return (0, _preact.h)("section", {
    className: (0, _classnames.default)('full-width', 'Template-brand-stats', 'custom-stats-bar')
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('stats-bar', 'p-v', 'qa-stats-bar')
  }, (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)("ul", {
    className: (0, _classnames.default)('list', 'list--stats-bar', 'qa-stats-bar')
  }, (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("strong", null, props.topictotal.toLocaleString(), " "), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
    p: "Topic|Topics"
  }))), (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("strong", null, props.reactiontotal.toLocaleString(), " "), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
    p: "Reply|Replies"
  }))), (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("strong", null, props.membertotal.toLocaleString(), " "), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
    p: "Members"
  })))), (0, _preact.h)("div", {
    id: "last-visitors-widget",
    className: (0, _classnames.default)('last-visitors', 'qa-last-visitors', 'is-hidden-M', 'pull-right')
  }, (0, _preact.h)(_LastVisitors.default, null))))));
};

var _default = CommunityStatisticsWidget;
exports.default = _default;